import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  paperStyle: {
    padding: '6px',
    marginBottom: '10px',
  },
  textIcon: {
    textDecoration: 'underline',
    display: 'flex',
    marginBottom: '15px',
    '& p': {
      marginLeft: '10px',
    },
  },
  textStyle: {
    display: 'grid',
    marginLeft: '15px',
    '& P': {
      lineHeight: '.5',
    },
  },
  boldTitle: {
    fontWeight: 'bold',
  },
  mainGrid: {
    minHeight: '110px',
  },
  dividerStyle: {
    height: '110px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textFlex: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  divider: {
    marginTop: 15,
    marginBottom: 15,
  },
  textFlexCenter: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-around',
    textAlign: 'center',
    margin: '10px',
  },
  imageStyle: {
    display: 'flex',
    maxWidth: 'fill-available',
    minWidth: 30,
  },
  gridEditButton: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  alignCenterSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  flexStart: {
    display: 'flex',
    justifyContent: 'flexStart',
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  servicesIconsPaper: {
    backgroundColor: '#f5f5f5',
    height: '95%',
    paddingRight: 30,
    paddingLeft: 30,
  },
  servicesIconsGrid: {
    textAlign: 'center',
  },
  servicesPaperTitle: {
    marginBottom: '10%',
    color: '#c4c4c4',
  },
  formGroupRow: {
    flexDirection: 'row',
  },
  title: {
    fontSize: 12,
  },
  appBar: {
    height: 48,
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: 'bold',
  },
  appbarStyle: {
    marginBottom: 15,
    fontWeight: 'bold',
  },
  gridEmailPhone: {
    minHeight: 114,
  },
  emailContainer: {
    margin: 5,
    overflow: 'scroll',
    maxWidth: '25rem',
  },
  fullWidth: {
    width: '100%',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  attributeItem: {
    display: 'flex',
    flexBasis: '50%',
    justifyContent: 'flex-start',
    margin: '1em 0',
    color: '#757575',
  },
  sectionDivider: {
    margin: '30px 0 20px',
    position: 'relative',
  },
  sectionDividerTitle: {
    backgroundColor: '#ffffff',
    padding: '0 3px',
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translate(8px, -50%)',
  },
  attributesForm: {
    margin: '1em 0',
  },
}));

export default styles;
